export default __webpack_public_path__ + "static/media/EvanHatter.9612d864.jpg";